module.exports = __webpack_public_path__ + "img/505fc74c758af7065de954e50aa4f0d7.svg";